import React from 'react'
import { Button } from 'react-bootstrap'
import { Pencil, Trash } from 'react-bootstrap-icons'
import AbsolutePosition from '../../common/absolute-position'
import useCurrentUser from '../../../hooks/use-current-user'
import DeleteButton from './delete-button'
import EditButton from './edit-button'

const AdminButtons = ({
    resource = {}
}) => {
    const { isAdmin } = useCurrentUser()
    if (!isAdmin) {
        return null
    }

    return (
        <React.Fragment>
            <AbsolutePosition top='20px' right='50px'>
                <EditButton resource={resource} />
            </AbsolutePosition>
            <AbsolutePosition top='20px' right='20px' >
                <DeleteButton resource={resource} />
            </AbsolutePosition>
        </React.Fragment>
    )
}

export default AdminButtons